import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/agent_queues.template.htm';
import CountersTemplate from 'text-loader!../templates/agent_queues_counters.template.htm';
import Collection from '../models/agents.paginated.collection.ts';
import CountersCollection from '../models/counters.paginated.collection.ts';
import 'dhtmlxMessage';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import i18n  from 'l10n';

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	countersTemplate: Handlebars.compile(CountersTemplate),
	superInitialize: GenericView.prototype.initialize,
    collection : null,
    userData: null,
	privilegeLevel: "",
	isFirstDisplay: true,
	loadingIndex: null,
	initialize: function (options) {
        var self = this;
        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);
        this.amIAssigned();

        $(window).off("beforeunload").on("beforeunload", function(e) {
            e.preventDefault(); //do not show Confirm popup

            self.clearListener("beforeunload");
        });

        this.setListener(); //set listener to Counters getting opened/closed

        this.interval = setInterval(function() { self.checkAndRenewSocketJSConnections(self); }, 10 * 1000);
	},
	amIAssigned: function()
    {
        var self = this;
        $.ajaxDefaultQ({
            url: "rest/api/agent/counters/assigned",
            type: "GET"
        }).done(function(response, status, xhr){
             if(status == "success")
             {
                if(response.data != null)
                    self.openCounterMonitor();
                else
                    self.loadAgentQueues();
             }
        }).fail(function(response) {
            self.loadAgentQueues();
        });
    },
    loadAgentQueues: function()
    {
        this.collection = new Collection();
        this.collection.state.pageSize = 999;
        this.collection.url = "rest/api/agents?extra=queue&filter=" + encodeURIComponent("user=" + this.userData.id);
        this.collection.on( 'sync', this.successQueueData, this );
        this.collection.on( 'error', this.errorQueueData, this );
        this.collection.getFirstPage();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();

        this.$el.html(this.template(
        {
            queues : this.collection.models,
            pageInfo : this.collection.info(),
            privilegeLevel: this.privilegeLevel
        }));
    },
    events: {
        "click .list-group-item": "joinQueue"
    },
    successQueueData: function()
    {
        var self = this;
        this.render();
        this.counterCollection = new CountersCollection();
        this.counterCollection.state.pageSize = 999;
        this.counterCollection.on('sync', this.successCountersData, this);
        this.counterCollection.on('error', this.errorCountersData, this);

        this.queueIds = "";
        for (var i=0; i<this.collection.models.length; i++)
        {
            var tempModel = this.collection.models[i];
            this.queueIds += tempModel.attributes.queue.id + ",";
        }
        this.queueIds = this.queueIds.substring(0, this.queueIds.length-1);
        this.loadCounterByQueueIds(this.queueIds);
    },
    errorQueueData: function(collection, xhr, options)
    {
        this.onErrorHandler(collection, xhr, options);
    },
    loadCounterByQueueIds: function(queueIds)
    {
        this.counterCollection.url =  "rest/api/counters?filter=" + encodeURIComponent("queue:" + queueIds);
        this.counterCollection.getFirstPage();
    },
    successCountersData: function()
    {
        var self = this;
        for (var i=0; i<this.collection.models.length; i++)
        {
            var tempModel = this.collection.models[i];
            this.queueId = tempModel.attributes.queue.id;
            this.tempCollection = this.counterCollection.models.filter( function(index) {
            	return index.attributes.queueId == self.queueId;
            });
            $("#resultOf"+this.queueId).html(this.countersTemplate({ counters: this.tempCollection }));
            this.queueId = null;
        }

    },
    errorCountersData: function(collection, xhr, options)
    {
        this.onErrorHandler(collection, xhr, options);
    },
    joinQueue: function(event)
    {
        this.clearListener();

        var self = this;
        var element = $(event.currentTarget);
        var queue = $($('.queueCard-'+ element.data("counter-queueid"))[0]);
        var qStatus = "";
        if(queue)
            qStatus = queue.data("queue-status");

        if(qStatus == "Closed")
        {
            $.notify(i18n.t("queue.queue_closed"), { position:"top center", className: "error"});
            return;
        }

        if(element.data("counter-status") == "Open")
        {
            $.notify(i18n.t("counter.counter_is_already_opened"), { position:"top center", className: "error"});
            return;
        }

        $.when(window.ping()).then(function(resp) {
            $.ajaxDefaultQ({
                url: "rest/api/agent/counters/open",
                type: "POST",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                },
                data: { counterId: element.data("counter-id") },
            }).done(function(response, status, xhr){

                self.openCounterMonitor();
                self.hideActionProgressBar();
            })
            .fail(function(response) {
                self.hideActionProgressBar();
                self.setListener(); //in case the counter did not open or can not be opened, re-establish the stomp connection
            });
        });


    },
    openCounterMonitor: function()
    {
         window.location.href = "#CounterMonitor";
    },
    setListener: function()
    {
        var self = this;
        //this.clearListener();

        this.wsocket = new SockJS('rest/live');
        this.client = Stomp.over(this.wsocket);

        var headers = {
            //origin: 'https://www.qedis.com', toDo: enable it
        };

        this.client.connect(headers, function(frame) {
            self.subscribeToStomp(self);
        },
        function(onCloseMessage) {
            if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                self.clearListener();
            }
        });
    },
	subscribeToStomp: function(self) {
	    self.stompAgentQueuesSubscription = self.client.subscribe('/live/agent/queues/counters', function (message){
            var parsedMessage = JSON.parse(message.body);
            if(parsedMessage.queueId)
                self.updateQueueStatus(parsedMessage);
            else if(parsedMessage.counterId)
                self.updateCounterStatus(parsedMessage);
        });
	},
    updateCounterStatus: function(resp) {
        var $counter = $($('[data-counter-id='+ resp.counterId +']')[0]);
        if($counter) {
            var $cStatus = $($counter.find(".counterStatus")[0]);
            if(resp.status == "Open") {
                $cStatus.removeClass("badge-danger");
                if(!$cStatus.hasClass("badge-success"))
                    $cStatus.addClass("badge-success");
            }else if(resp.status == "Closed") {
                $cStatus.removeClass("badge-success");
                if(!$cStatus.hasClass("badge-danger"))
                    $cStatus.addClass("badge-danger");
            }

            $counter.data("counter-status", resp.status); //update status, to disable the opening of the Counter, if it's already open

            $cStatus.text(Handlebars.helpers.defaultValueInCaseOfNullWithTranslation("counter", resp.status, "Closed"));
        }
    },
    updateQueueStatus: function(resp) {
        var $queue = $($('.queueCard-'+ resp.queueId)[0]);
        if($queue) {
            var $qStatus = $($queue.find(".queueStatus")[0]);
            if(resp.status == "Open") {
                $qStatus.removeClass("badge-danger");
                if(!$qStatus.hasClass("badge-success"))
                    $qStatus.addClass("badge-success");
            }else if(resp.status == "Closed") {
                $qStatus.removeClass("badge-success");
                if(!$qStatus.hasClass("badge-danger"))
                    $qStatus.addClass("badge-danger");
            }

            $qStatus.text(Handlebars.helpers.defaultValueInCaseOfNullWithTranslation("queue", resp.status, "Closed"));
        }
    },
    clearListener: function()
    {
        var self = this;
        if(!this.client || !this.stompAgentQueuesSubscription || this.alreadyRequestedClear)
            return;

        this.alreadyRequestedClear = true;

        this.stompAgentQueuesSubscription.unsubscribe();
        this.stompAgentQueuesSubscription = null;
        /*this.client.disconnect(function() {

        });*/

        this.alreadyRequestedClear = false;
    },
    clearView: function()
    {
        this.clearListener();
    },
    checkAndRenewSocketJSConnections: function(self) {
        //console.log(">>> Checking for non-connected client.");
      	if(self.client && (!self.client.connected || !self.stompAgentQueuesSubscription)) {
            //console.log("Found non-connected client. Trying to reconnect...");
            //self.setListener();
            self.subscribeToStomp(self);
        }else {
            //console.log("No disconnected client found.");
        }
    }
});

